import styled from 'styled-components';

export const HipermapaContainer = styled.div`
  font-family: 'Open Sans', sans-serif;
`;

export const NavbarContainer = styled.div`
  z-index: 9;

  @media screen and (max-width: 1028px) {
    transition: 0.8s all ease;
    display: flex;
  }

  @media screen and (max-width: 768px) {
    display: block;
  }
`;

export const SidebarContainer = styled.div``;

export const CatalogContainer = styled.div``;

export const MapContainer = styled.div`
  height: ${(props) => props.mapHeight};
  display: flex;

  @media screen and (max-width: 768px) {
    height: ${(props) => (props.displayNav ? props.mapHeight : `${parseInt(props.mapHeight) + 40}px`)};
  }
`;
